import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import {
  StockMovementType,
  StockMovementTypeLabel,
} from "features/StockMovements/constants/stock-movement.constants";

export type StockMovementListFiltersProps = {
  movementTypeFilter: StockMovementType | "";
  productIdFilter: number | "";
  locationIdFilter: number | "";
  onMovementTypeChange: (value: StockMovementType | "") => void;
  onProductIdChange: (value: number | "") => void;
  onLocationIdChange: (value: number | "") => void;
};

export default function StockMovementListFilters({
  movementTypeFilter,
  productIdFilter,
  locationIdFilter,
  onMovementTypeChange,
  onProductIdChange,
  onLocationIdChange,
}: StockMovementListFiltersProps) {
  return (
    <Row className="g-3">
      <Col xs={12}>
        <Label className="form-label text-muted small mb-1">Type</Label>
        <Input
          type="select"
          className="form-select form-select-sm"
          value={movementTypeFilter}
          onChange={(e) =>
            onMovementTypeChange(
              (e.target.value || "") as StockMovementType | "",
            )
          }
        >
          <option value="">All types</option>
          {(Object.values(StockMovementType) as StockMovementType[]).map(
            (t) => (
              <option key={t} value={t}>
                {StockMovementTypeLabel[t]}
              </option>
            ),
          )}
        </Input>
      </Col>
      <Col xs={12}>
        <Label className="form-label text-muted small mb-1">Product ID</Label>
        <Input
          type="number"
          className="form-control form-control-sm"
          placeholder="Filter by product"
          value={productIdFilter === "" ? "" : productIdFilter}
          onChange={(e) => {
            const v = e.target.value;
            onProductIdChange(v === "" ? "" : Number(v));
          }}
        />
      </Col>
      <Col xs={12}>
        <Label className="form-label text-muted small mb-1">Location ID</Label>
        <Input
          type="number"
          className="form-control form-control-sm"
          placeholder="From or to location"
          value={locationIdFilter === "" ? "" : locationIdFilter}
          onChange={(e) => {
            const v = e.target.value;
            onLocationIdChange(v === "" ? "" : Number(v));
          }}
        />
      </Col>
    </Row>
  );
}
